import { BASE_API_URL } from "./constants.js"

export const getPrices = async () => {
    const response = await fetch(BASE_API_URL + 'prices/', {
        "headers": {
            "Accept-Encoding": "gzip, compress, br",
        }
    })
    const apiPrices = await response.json()
    return apiPrices
}

export const getSurcharges = async () => {
    const response = await fetch(BASE_API_URL + 'surcharges/', {
        "headers": {
            "Accept-Encoding": "gzip, compress, br",
        }
    })
    const apiSurcharges = await response.json()
    return apiSurcharges
}

export const formatCurrency = (inputNumber) => {
    return `${inputNumber.toFixed(2).replace('.', ',')} €`
}

export const calculateVacationEstimate = (formData, aptPrices, aptSurcharges) => {
    // Extract form data
    const {
        arrival,
        departure,
        noOfAdults = formData.noOfAdults >= 2 ? formData.noOfAdults : 2,
        noOfChildren,
        noOfPets
    } = formData
    const apartment = 'david' // we assume the best price

    const adultPrice = getSurchargeAmount(aptSurcharges, "ADDITIONALADULT")
    //const childPrice = getSurchargeAmount(aptSurcharges, "ADDITIONALCHILD")
    const childUnder6Price = getSurchargeAmount(aptSurcharges, "ADDITIONALCHILDUNDER6")
    const petPrice = getSurchargeAmount(aptSurcharges, "ADDITIONALPET")
    const shortStaySurcharge = getSurchargeAmount(aptSurcharges, "LESSTHAN3NIGHTS")
    const touristTax = getSurchargeAmount(aptSurcharges, "LOCALTAX")

    // Calculate total nights
    const nights = calculateNights(arrival, departure)

    // Initialize cost calculation
    let breakdown = {
        basePrice: 0,
        extraAdultsCost: 0,
        childrenUnder6Cost: 0,
        children6to14Cost: 0,
        petCost: 0,
        touristTaxCost: 0,
        shortStaySurchargeCost: 0
    }

    // If dates are not provided or invalid, return zero cost
    if (!arrival || !departure || nights <= 0) {
        return {
            breakdown,
            totalCost: 0,
            totalNights: 0,
            isValid: false
        }
    }

    // Calculate base price for all nights
    let currentDate = new Date(arrival)
    const endDate = new Date(departure)

    while (currentDate < endDate) {
        breakdown.basePrice += getPriceForDate(aptPrices, currentDate, apartment)
        currentDate.setDate(currentDate.getDate() + 1)
    }

    // Calculate extra person costs (only for people beyond the first 2)
    const extraAdults = Math.max(0, noOfAdults - 2)
    breakdown.extraAdultsCost = extraAdults * adultPrice * nights
    breakdown.childrenUnder6Cost = noOfChildren * childUnder6Price * nights

    // Calculate pet costs
    breakdown.petCost = noOfPets * petPrice * nights

    // Calculate tourist tax (only for people 14+ years old)
    const taxablePeople = noOfAdults + noOfChildren
    breakdown.touristTaxCost = taxablePeople * touristTax * nights

    // Add short stay surcharge if applicable (less than 3 nights)
    if (nights > 0 && nights < 3) {
        breakdown.shortStaySurchargeCost = shortStaySurcharge * nights
    }

    // Calculate total cost
    const totalCost = Object
        .values(breakdown)
        .reduce((sum, cost) => sum + cost, 0)

    return {
        breakdown,
        totalCost,
        totalNights: nights,
        isValid: nights >= 3 // Minimum 3-night stay requirement
    }
}

// Get surcharge values from API response
const getSurchargeAmount = (aptSurcharges, type) => {
    const surcharge = aptSurcharges.find(s => s.surcharge === type);
    return surcharge ? surcharge.cost : 0;
}

// Calculate nights between two dates
const calculateNights = (checkIn, checkOut) => {
    if (!checkIn || !checkOut)
        return 0
    const startDate = new Date(checkIn)
    const endDate = new Date(checkOut)
    const timeDiff = endDate.getTime() - startDate.getTime()
    return Math.ceil(timeDiff / (1000 * 3600 * 24))
}

// Get price for a specific date
const getPriceForDate = (aptPrices, date, selectedApartment) => {
    const month = date.getMonth() + 1
    const monthStr = month < 10 ? `0${month}` : `${month}`
    return aptPrices[selectedApartment]?.[monthStr] || 0
}
